import { useEffect } from "react";

interface UseHandleResizeProps {
    setWindowHeight: React.Dispatch<React.SetStateAction<number>>
}

export const useHandleResize = ({ setWindowHeight }: UseHandleResizeProps) => {
    useEffect(() => {
        const handleResize = () => {
            setWindowHeight(window.innerHeight);
        };
        window.addEventListener("resize", handleResize);
        
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = '';
        };
    }, []);
}